/* Compte à rebours de l'offre (Réglages du thème, « Offre COCOONDAYS »).
   - La date de fin est saisie à l'heure de Paris (AAAA-MM-JJ HH:MM) : tous les visiteurs voient la même fin, où qu'ils soient.
   - Si la date est invalide ou passée, le compte à rebours reste caché. Il ne repart jamais tout seul. */
(function () {
  if (window.__cocoonCountdown) return;
  window.__cocoonCountdown = true;

  var ZONE = 'Europe/Paris';

  function zoneOffset(ms) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: ZONE, hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(new Date(ms));
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return Date.UTC(+o.year, +o.month - 1, +o.day, +o.hour, +o.minute, +o.second) - ms;
  }

  function parseEnd(text) {
    text = String(text || '').trim();
    if (!text) return NaN;
    // Date complète avec fuseau (2026-10-18T23:59:00+02:00 ou ...Z) : on la prend telle quelle.
    if (text.length > 10 && /(Z|[+-]\d{2}:?\d{2})$/i.test(text)) return Date.parse(text);
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2})(?::(\d{2}))?(?::(\d{2}))?)?$/.exec(text);
    if (!m) return NaN;
    var y = +m[1], mo = +m[2] - 1, d = +m[3], h = +(m[4] || 0), mi = +(m[5] || 0), s = +(m[6] || 0);
    var guess = Date.UTC(y, mo, d, h, mi, s);
    try {
      var first = guess - zoneOffset(guess);
      return guess - zoneOffset(first);
    } catch (e) {
      return new Date(y, mo, d, h, mi, s).getTime();
    }
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function setText(root, key, value) {
    var node = root.querySelector('[data-cd="' + key + '"]');
    if (node && node.textContent !== value) node.textContent = value;
  }

  function tick() {
    var list = document.querySelectorAll('[data-countdown]');
    var now = Date.now();
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.__cdEnd === undefined) el.__cdEnd = parseEnd(el.getAttribute('data-countdown'));
      var left = el.__cdEnd - now;
      if (!(left > 0)) { if (!el.hidden) el.hidden = true; continue; }
      if (el.hasAttribute('data-wait')) el.removeAttribute('data-wait');
      var total = Math.floor(left / 1000);
      var days = Math.floor(total / 86400);
      setText(el, 'd', pad(days));
      setText(el, 'h', pad(Math.floor((total % 86400) / 3600)));
      setText(el, 'm', pad(Math.floor((total % 3600) / 60)));
      setText(el, 's', pad(total % 60));
      var dayBox = el.querySelector('[data-cd-u="d"]');
      if (dayBox && dayBox.hidden !== (days === 0)) dayBox.hidden = days === 0;
      el.classList.toggle('is-soon', total < 86400);
    }
  }

  tick();
  window.setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', tick);
})();
